import { logError } from "./errorLogger";

type Metric = { name: string; value: number; rating?: string; id: string };

const POOR_THRESHOLDS: Record<string, number> = {
  LCP: 4000,
  CLS: 0.25,
  INP: 500,
  FCP: 3000,
  TTFB: 1800,
};

function report(metric: Metric) {
  const poor = POOR_THRESHOLDS[metric.name];
  if (poor && metric.value > poor) {
    logError({
      message: `Poor ${metric.name}: ${Math.round(metric.value)}`,
      severity: "warn",
      source: "vitals",
      context: { metric: metric.name, value: metric.value, rating: metric.rating },
    });
  }
}

export async function startWebVitals() {
  if (typeof window === "undefined") return;
  try {
    const mod = await import("web-vitals");
    mod.onCLS?.(report);
    mod.onLCP?.(report);
    mod.onINP?.(report);
    mod.onFCP?.(report);
    mod.onTTFB?.(report);
  } catch {
    // web-vitals optional, never break the app
  }
}